import React from 'react';
import Image from 'next/image';
import styles from './WhoWeAre.module.scss';
import Reveal from 'react-awesome-reveal';
import { flipFromLeft, flipFromRight } from '../Animation/Animation';
import { Typography } from '../Typography';

const WhoWeAre = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.leftSection}>
          <Reveal keyframes={flipFromLeft} duration={1000} delay={100} triggerOnce>
            <Typography variant="text-md" color="grayDark-300" weight="medium" className={styles.label}>
              Who We Are
            </Typography>
            <Typography variant="display-md" as="h2" color="grayDark-50" weight="semibold" className={styles.heading}>
              A team building production
            </Typography>
            <Typography variant="text-lg" color="grayDark-600" className={styles.description}>
              EPEN is a technology-driven company focused on building professional tools and frameworks for video development and high-performance software systems. We help developers, studios, and production teams design, build, and scale advanced video solutions with precision, performance, and reliability.
            </Typography>
            <Typography variant="text-lg" color="grayDark-600" className={styles.description}>
              We believe that powerful tools should simplify complexity — not add to it.
            </Typography>
          </Reveal>
        </div>
        <div className={styles.rightSection}>
          <Reveal keyframes={flipFromRight} duration={1000} delay={200} triggerOnce>
            <div className={styles.imageWrapper}>
              <Image
                src="/about/who-we-are.jpg"
                alt="Who We Are"
                layout="fill"
                objectFit="cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;

